import gsap, { Power2 } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { Ease } from '../_app/cuchillo/utils/Ease';
import { Basics } from '../_app/cuchillo/core/Basics';

class ScrollItem__BlockTitle extends VScroll_Item {
  _title;

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    let title = GetBy.selector('.__title p', __link)[0];
    if (!title) title = GetBy.class('__title', __link)[0];

    new SplitText(title, {
      type: 'words',
      wordsClass: 'line-parent'
    });
    this._title = new SplitText(title, {
      type: 'words',
      wordsClass: 'line-children'
    }).words;
    gsap.set(this._title, { y: '100%' });

    this.onShow = () => {
      for (let i = 0; i < this._title.length; i++) {
        const item = this._title[i];
        gsap.to(item, {
          y: 0,
          duration: 1.2,
          delay: i * 0.2,
          ease: Ease.EASE_CUCHILLO_OUT
        });
      }
    };
    this.onHide = () => { };
    this.onMove = () => { };
  }

  //==================================================================================================================
  //          PUBLIC
  //==================================================================================================================
}

Scroll._registerClass('BlockTitle', ScrollItem__BlockTitle);
